















import { Vue, Component, Prop } from "vue-property-decorator";
import Trianglify from "trianglify";
import { STORE_URL, SHOP_PAGE_PATH } from "@/constants";
import { currentUserStore, customizationStore } from "@/store/typed";

@Component({})
export default class Error extends Vue {
  mounted() {
    const el = document.getElementById("triangle-layer");
    el.appendChild(this.generatePattern());
  }

  generatePattern() {
    const pattern = Trianglify({
      width: window.innerWidth,
      height: window.innerHeight,
      fill: false,
      strokeWidth: 3,
      cellSize: Math.ceil(window.innerWidth / 8),
      colorFunction: Trianglify.colorFunctions.interpolateLinear(0.5),
      palette: [
        [
          "#0d0d0d",
          "#1c1c1c",
          "#0d0d0d",
          "#1c1c1c",
          "#0d0d0d",
          "#1c1c1c",
          "#0d0d0d",
        ],
      ],
    });
    const el = document.getElementById("triangle-layer");
    return pattern.toCanvas();
  }

  get referrer() {
    return currentUserStore.referrer || `${STORE_URL}/${SHOP_PAGE_PATH}`;
  }

  async onBack() {
    localStorage.removeItem("ilmyo_customizer");
    window.location.assign(this.referrer);
  }
}
